<template>
    <Wrapper :is-global-page="isGlobalPage" :is-loading="isBusy">
        <div class="row" :style="{ 'margin-bottom': isGlobalPage ? '0px' : '20px' }">
            <div class="col-sm-6" v-if="!isGlobalPage">
                <a :href="url(`/admin/employer/${employerId}/resend-applications`)" class="btn btn-primary">
                    <i class="fa fa-repeat" aria-hidden="true"></i> Resend Drivers
                </a>
            </div>
            <div :class="[ isGlobalPage ? 'col-sm-12' : 'col-sm-6', 'text-right']">
                <span v-if="pagination.total > 0">Leads {{ currentPageText }} out of {{ pagination.total }}</span>
            </div>
        </div>

        <Filters v-bind:value="filters"
                 v-on:input="setFilters($event)"
                 :is-global-page="isGlobalPage"
                 :app-types-options="appTypesOptions"
                 :campaigns-options="campaignsOptions"
                 :employers-options="employersOptions"
                 :jobs-options="jobsOptions"
                 :state-options="stateOptions"
                 :cdl-xp-options="cdlXpOptions"
                 :cdl-a-options="cdlAOptions"
                 :source-options="sourceOptions"
                 :agents-options="agentsOptions"/>

        <Table :employer-cols-enabled="isGlobalPage" :data="data"/>

        <div class="row" v-if="pagination.total > 1">
            <div class="col-sm-12 text-center">
                <el-pagination layout="prev, pager, next"
                               background
                               v-bind:current-page.sync="pagination.page"
                               @current-change="changePage"
                               :page-size="pagination.perPage"
                               :total="pagination.total"/>
            </div>
        </div>
        <employer-notes-wrapper v-if="employerId" :employer-id="employerId" />
    </Wrapper>
</template>

<script>
import Filters from './applications-list/applications-filters.vue';
import Table from './applications-list/applications-table.vue';
import Wrapper from './applications-list/applications-wrapper.vue';

export default {
        components: { Filters, Table, Wrapper },
        props: {
            employerId: { type: Number, required: false, default: null },
            appTypesOptions: { type: Object, required: true },
            employersOptions: { type: Object, required: false, default: null },
            campaignsOptions: { type: Object, required: false, default: null },
            jobsOptions: { type: Object, required: false, default: null },
            stateOptions: { type: Object, required: false, default: null },
            cdlXpOptions: { type: Object, required: true },
            cdlAOptions: { type: Object, required: true },
            sourceOptions: { type: Object, required: true },
            agentsOptions: { type: Object, required: true },
        },
        data() {
            // let's set from date to current month
            let date = new Date();
            let year = date.getFullYear();
            let month = (date.getMonth() + 1);

            if (month > 12) {
                year++;
                month = 1;
            }
            month += '';
            if (month.length === 1) month = '0' + month;

            return {
                isBusy: false,
                data: [],
                filters: {
                    from: year + '-' + month + '-01',
                    to: '',
                    campaign: [],
                    job: [],
                    name: '',
                    email: '',
                    phone: '',
                    zip: '',
                    state: '',
                    appType: '',
                    minCdlXp: '',
                    maxCdlXp: '',
                    minCdlA: '',
                    maxCdlA: '',
                    source: '-1',
                    agent: '',
                    employer: '',
                    title: '',
                },
                pagination: {
                    perPage: 50,
                    page: 1,
                    total: 0,
                },
            };
        },
        mounted() {
            this.getData();
        },
        computed: {
            isGlobalPage() {
                return this.employerId === null;
            },
            currentPageText() {
                const perPage = parseInt(this.pagination.perPage);
                const page = parseInt(this.pagination.page);
                const total = parseInt(this.pagination.total);

                let currentPageCount = (perPage * page);
                if (total < currentPageCount) currentPageCount = total;

                return ((perPage * page) - perPage + 1) + ' - ' + currentPageCount;
            },
        },
        methods: {
            setFilters(newFilters) {
                this.filters = _.cloneDeep(newFilters);
                this.getData();
            },
            changePage() {
                this.getData();
            },
            getData() {
                const $this = this;
                $this.isBusy = true;

                const params = this.filters;
                params['employerId'] = $this.isGlobalPage ? $this.filters.employer : $this.employerId;
                params['perPage'] = $this.pagination.perPage;
                params['page'] = $this.pagination.page;

                axios.get(url(`admin/applications/get-list`), { 'params': params })
                     .then(response => {
                         if (typeof response.data.success === 'undefined' || !response.data.success) {
                             throw Error('Something goes wrong.');
                         }

                         $this.data = response.data.list;
                         $this.pagination.total = response.data.rowCount;
                     })
                     .catch(err => $this.$message.error(err.message))
                     .finally(() => $this.isBusy = false);
            },
        },
    };
</script>
